import React from "react";
import { Link } from "react-router-dom";
import { SEOHeadV2 } from "../../components/SEOHeadV2";

const wrap = {
  minHeight: "100vh",
  background: "#0d1f3c",
  color: "#f4efe6",
  fontFamily: "Merriweather, Georgia, serif",
  padding: "60px 24px",
};
const inner = { maxWidth: 880, margin: "0 auto" };
const h1 = {
  fontFamily: "Cinzel, Trajan Pro, Georgia, serif",
  color: "#c9a84c",
  fontSize: 36,
  letterSpacing: 2.5,
  textTransform: "uppercase",
  marginBottom: 8,
};
const lede = {
  color: "rgba(244,239,230,0.7)",
  fontSize: 13,
  letterSpacing: 1,
  marginBottom: 28,
};
const h2 = {
  fontFamily: "Cinzel, Georgia, serif",
  color: "#c9a84c",
  fontSize: 18,
  letterSpacing: 1.5,
  marginTop: 28,
  marginBottom: 10,
  textTransform: "uppercase",
};
const p = { color: "#f4efe6", fontSize: 14, lineHeight: 1.8, marginBottom: 12 };
const ul = { color: "#f4efe6", fontSize: 14, lineHeight: 1.9, paddingLeft: 22 };
const back = {
  display: "inline-block",
  marginTop: 32,
  color: "#c9a84c",
  fontFamily: "Cinzel, Georgia, serif",
  letterSpacing: 1.5,
  textDecoration: "none",
  borderBottom: "1px solid #c9a84c",
};

export const Privacy = () => (
  <div style={wrap} data-testid="page-privacy">
    <SEOHeadV2 />
    <div style={inner}>
      <h1 style={h1} data-testid="privacy-title">Privacy Policy</h1>
      <div style={lede}>AuditIQ Sports — Effective {new Date().getFullYear()}</div>

      <p style={p}>
        AuditIQ Sports operates as an institutional oversight platform for university and high school
        athletic programs. This policy describes how we handle athlete data, employ HIPAA-aware
        practices, and protect institutional information shared with our system.
      </p>

      <h2 style={h2}>What We Collect</h2>
      <ul style={ul}>
        <li>Roster, schedule, and statistical data sourced from public institutional websites under robots.txt-respecting crawls.</li>
        <li>Health IQ inputs (workload, recovery, availability) submitted by certified athletic trainers and coaching staff.</li>
        <li>Audit-trail metadata for every administrative action performed on the platform.</li>
      </ul>

      <h2 style={h2}>HIPAA-Aware Practices</h2>
      <p style={p}>
        AuditIQ Sports does not store raw protected health information (PHI). Health IQ scoring is
        derived from de-identified workload and availability inputs. Medical record fields are never
        exposed to the demo_user role, and access by all other roles is mediated by JWT-enforced
        role-based access control.
      </p>

      <h2 style={h2}>Demo Mode</h2>
      <p style={p}>
        When DEMO_MODE is enabled, all displayed athlete information is synthetic seed data and is
        clearly labelled "Demo Data — Not Real Athlete Records." No real user accounts or medical
        records are exposed in demo mode under any condition.
      </p>

      <h2 style={h2}>Data Sharing</h2>
      <p style={p}>
        AuditIQ Sports does not sell athlete or institutional data. Reports exported from the
        platform remain the property of the institution that generated them.
      </p>

      <h2 style={h2}>Contact</h2>
      <p style={p}>
        Privacy inquiries: <a style={{ color: "#c9a84c" }} href="mailto:privacy@i-audit.com">privacy@i-audit.com</a>
      </p>

      <Link to="/dashboard" style={back} data-testid="privacy-back">← Return to Dashboard</Link>
    </div>
  </div>
);

export const Terms = () => (
  <div style={wrap} data-testid="page-terms">
    <SEOHeadV2 />
    <div style={inner}>
      <h1 style={h1} data-testid="terms-title">Terms of Service</h1>
      <div style={lede}>AuditIQ Sports — Effective {new Date().getFullYear()}</div>

      <p style={p}>
        These terms govern the use of the AuditIQ Sports platform by institutional users, athletic
        programs, and university administrators. By accessing the platform you agree to operate
        within the role-based permission boundaries assigned to your account.
      </p>

      <h2 style={h2}>Permitted Use</h2>
      <ul style={ul}>
        <li>Authorized institutional staff may access dashboards, generate reports, and execute compliance workflows on behalf of their organization.</li>
        <li>Demo accounts are read-only and may not be used for editing, approval, or export of real institutional data.</li>
        <li>System auditors hold read-only access to system logs and may not modify any record.</li>
      </ul>

      <h2 style={h2}>Compliance &amp; Defensive Posture</h2>
      <p style={p}>
        AuditIQ Sports is intended for defensive institutional oversight. Users may not employ the
        platform for offensive intelligence gathering, harassment of individuals, or any unlawful
        purpose. Crawling configuration is robots.txt-respecting and rate-limited at the platform
        level.
      </p>

      <h2 style={h2}>Limitation of Liability</h2>
      <p style={p}>
        AuditIQ Sports provides analytical tooling; it does not replace medical judgement, NCAA or
        FHSAA compliance counsel, or institutional policy. Users are responsible for verifying any
        recommendation produced by the platform before acting on it.
      </p>

      <h2 style={h2}>Termination</h2>
      <p style={p}>
        Institutional licences may be terminated for material breach of these terms or for misuse of
        the demo or auditor roles.
      </p>

      <h2 style={h2}>Contact</h2>
      <p style={p}>
        Legal inquiries: <a style={{ color: "#c9a84c" }} href="mailto:legal@i-audit.com">legal@i-audit.com</a>
      </p>

      <Link to="/dashboard" style={back} data-testid="terms-back">← Return to Dashboard</Link>
    </div>
  </div>
);
